import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.VRR2P3PQ.js";
import {
  applyStyles
} from "./chunk.WXNWU2SV.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-multi-form/jb-multi-form.scss?inline
var jb_multi_form_default = i`jb-multi-form {
  /* stylelint-disable */
  /* COLOR SETTINGS */
  /* shadows */
  /* special measurements */
  /* stylelint-disable */
  /* stylelint-enable */
  /* special measurements */
  /* stylelint-enable */
  display: block;
}
jb-multi-form *,
jb-multi-form *::before,
jb-multi-form *::after {
  box-sizing: border-box;
}
jb-multi-form div,
jb-multi-form object,
jb-multi-form iframe,
jb-multi-form h1,
jb-multi-form h2,
jb-multi-form h3,
jb-multi-form h4,
jb-multi-form h5,
jb-multi-form h6,
jb-multi-form p,
jb-multi-form blockquote,
jb-multi-form ol,
jb-multi-form ul,
jb-multi-form li,
jb-multi-form form,
jb-multi-form legend,
jb-multi-form label,
jb-multi-form table,
jb-multi-form header,
jb-multi-form footer,
jb-multi-form nav,
jb-multi-form section,
jb-multi-form figure {
  margin: 0;
  padding: 0;
}
jb-multi-form a {
  color: inherit;
}
jb-multi-form :host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}
@media screen and (width >= 1281px) {
  jb-multi-form :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
jb-multi-form h3 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}
jb-multi-form h3 {
  font-size: var(--theme-typo-h3-mobile-fontsize, 1.375rem);
  line-height: var(--theme-typo-h3-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  jb-multi-form h3 {
    font-size: var(--theme-typo-h3-desktop-fontsize, 1.625rem);
    line-height: var(--theme-typo-h3-desktop-lineheight, 2.25rem);
  }
}
jb-multi-form :host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}
@media screen and (width >= 1281px) {
  jb-multi-form :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
jb-multi-form :host {
  color: var(--host-color, #141e55);
}
jb-multi-form .wrapper {
  margin-block-end: var(--spacing-xs);
  position: relative;
  z-index: 2;
}
jb-multi-form jb-form {
  opacity: 1;
  position: relative;
  transition: opacity 0.3s ease-in-out;
  z-index: 1;
}
jb-multi-form jb-form.paused {
  opacity: 0.4;
  pointer-events: none;
}
jb-multi-form h3 {
  margin-block-end: var(--spacing-xs);
}`;

// src/components/jb-multi-form/jb-multi-form.ts
var JbMultiForm = class extends Spaceable(Animatable(h)) {
  constructor() {
    super(...arguments);
    this.formsToDisplay = [];
    this._formOptions = [];
  }
  connectedCallback() {
    super.connectedCallback();
    applyStyles(this, jb_multi_form_default);
    this._formOptions = [
      ...this.formsToDisplay.map((form) => ({
        label: form.formTitle,
        value: form.formIdentifier
      }))
    ];
    const initialIdentifier = this.preselectedFormIdentifier ?? this.formsToDisplay[0].formIdentifier;
    if (this.preselectedForm) {
      this._currentFormProperties = this.preselectedForm;
    } else {
      this._currentFormProperties = this.formsToDisplay.find((i2) => i2.formIdentifier === initialIdentifier).form;
    }
    this.contentDuration = 150;
    this.contentStagger = 75;
  }
  createRenderRoot() {
    return this;
  }
  async firstUpdated() {
    this._trackFormChange();
    await this.updateComplete;
    const initialIdentifier = this.preselectedFormIdentifier ?? this.formsToDisplay[0].formIdentifier;
    this._select.setValue(initialIdentifier);
    if (this.promptForSelection) {
      const hiddenField = document.createElement("jb-text-field");
      hiddenField.setAttribute("requiredText", "*");
      hiddenField.setAttribute("type", "hidden");
      await this._currentForm.updateComplete;
      this._currentForm.append(hiddenField);
      this._select.value = "";
      this._currentForm.addEventListener("jb-button:clicked", async (e2) => {
        if (e2.detail.name === "submit") {
          this._validateMultiformSelector();
        }
      });
    }
  }
  _captureTracking(evt) {
    evt.stopPropagation();
  }
  _formShow(formIdentifier) {
    this._trackFormChange();
    this._currentForm.classList.add("paused");
    this.contentChildren = Array.from(this._currentForm.children);
    this.animateContent(true).then(() => {
      this._currentFormProperties = this.formsToDisplay.find((i2) => i2.formIdentifier === formIdentifier).form;
      this._currentForm.classList.remove("paused");
    });
  }
  _getContentSpacingProperties() {
    return { grid: "legacy", colsMdUp: 8, colsLgUp: 6 };
  }
  async _selectChanged() {
    if (!this._select.value) return;
    const requiredField = this._currentForm?.querySelector('[requiredtext="*"]');
    if (requiredField) {
      this._currentForm?.removeChild(requiredField);
    }
    this._formShow(this._select.value);
  }
  _trackFormChange() {
    const selectRoot = this._select.shadowRoot ?? this._select;
    const selectText = selectRoot.querySelector("[data-ts-item]");
    const trackingDetail = {
      event: "ce_form",
      event_version: "v2",
      component_name: "multi-contact-form",
      form_step_name: !selectText ? "form open" : "form type select",
      form_step_nr: !selectText ? "1" : "1.5",
      form_subject: !selectText ? "skeleton contact form" : selectText.innerText,
      form_type: "contact"
    };
    if (selectText) {
      trackingDetail.interaction_text = selectText.innerText;
    }
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: trackingDetail,
        bubbles: true,
        composed: true
      })
    );
  }
  _validateMultiformSelector() {
    const select = this.querySelector("jb-select");
    if (select.validate) {
      return select.validate();
    }
    return null;
  }
  render() {
    return ke`
      <div class="wrapper">
        <h3>${this.headline}</h3>
        <jb-select
          id="formSelect"
          .options=${this._formOptions}
          showLabel
          .requiredText=${this.requiredText}
          .label=${this.label}
          .placeholder=${this.promptForSelection}
          type="ismultiform"
          @jb-select:changed=${this._selectChanged}
        ></jb-select>
      </div>
      <jb-form
        .action=${this._currentFormProperties.action}
        .additionalData=${this._currentFormProperties.additionalData}
        .bordered=${this._currentFormProperties.bordered}
        .contentElements=${this._currentFormProperties.contentElements}
        .formHeader=${this._currentFormProperties.formHeader}
        .formIdentifier=${this._currentFormProperties.formIdentifier}
        .generalConcern=${this._currentFormProperties.generalConcern}
        .multiformSubline=${this._currentFormProperties.multiformSubline}
        .recipient=${this._currentFormProperties.recipient}
        .recipientPhone=${this._currentFormProperties.recipientPhone}
        .recipientPosition=${this._currentFormProperties.recipientPosition}
        .trackingSubject=${this._currentFormProperties.trackingSubject}
        .validationFieldname=${this._currentFormProperties.validationFieldname}
        displayGrid
        @jb-tracking=${this._captureTracking}
      ></jb-form>
    `;
  }
};
JbMultiForm.styles = r(jb_multi_form_default);
__decorateClass([
  n({ type: Array })
], JbMultiForm.prototype, "formsToDisplay", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "headline", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "label", 2);
__decorateClass([
  n({ type: Object })
], JbMultiForm.prototype, "preselectedForm", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "preselectedFormIdentifier", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "promptForSelection", 2);
__decorateClass([
  n()
], JbMultiForm.prototype, "requiredText", 2);
__decorateClass([
  e("jb-form")
], JbMultiForm.prototype, "_currentForm", 2);
__decorateClass([
  r2()
], JbMultiForm.prototype, "_currentFormProperties", 2);
__decorateClass([
  e("#formSelect")
], JbMultiForm.prototype, "_select", 2);
JbMultiForm = __decorateClass([
  customElement("jb-multi-form")
], JbMultiForm);

export {
  JbMultiForm
};
